import "./cryptoPrice.css";
import TradingViewWidget, { Themes } from "react-tradingview-widget";
import imageDoj from "../../assets/images/274692-P5ONYR-17-removebg-preview.svg";
import imageLight from "../../assets/images/274692--173-removebg-preview.svg";
import imageEth from "../../assets/images/2746P5ONYR-173-removebg-preview.svg";
import imageDash from "../../assets/images/274692-P5ONY3-removebg-preview.svg";
import imageHrp from "../../assets/images/light.svg";
import log from "../../assets/images/log.svg";
import styles from "../sarafiComponents/sarafi.module.css";
import { maskNumber } from "utils/helperFunctions";
function CryptoPrices({ information, USDTPrice }) {
  console.log("information", information);
  return (
    <>
      <div className="d-flex justify-content-center align-items-center">
        <img src={log} className={styles.log} />
      </div>
      <div
        className={`d-flex justify-content-evenly align-items-center ${styles.sarafiContainer}`}
      >
        <h5 className="mt-2">قیمت ارزهای دیجیتال در صرافی اوکی اکسچنج</h5>

        <p className={styles.siteColor}>
          آدرس سایت <span> : </span> <bdi>www.xchange.com </bdi>
        </p>
      </div>

      <div className="containerMain">
        <div className="scroll-table mb-5 table-responsive">
          <table className="table">
            <thead>
              <tr className="text-center py-2">
                <th height="75" className="text-center">
                  ارز
                </th>
                <th className=" text-center">نام صرافی</th>
                <th> خرید به ریال</th>
                <th> خرید به تتر</th>
                <th> فروش به ریال</th>
                <th>فروش به تتر</th>
              </tr>
            </thead>
          </table>
          <div className="scroll-table-body">
            <table>
              <tbody>
                {information?.map((value) => {
                  return (
                    <tr className="" height="75">
                      <td className="mt-auto d-flex justify-content-between">
                        <img
                          src={value.cc_meta.logo}
                          className="img-doj"
                          alt="coin"
                        />
                        <div className="d-flex flex-column  ">
                          <p className="textDoj">{value.cc_meta.farsi_name}</p>
                          <p className="textFont">{`${value.cc_meta.name}(${value.cc_meta.symbol})`}</p>
                        </div>
                      </td>
                      <td>{value.echange.exhnage_name}</td>
                      <td className="text-danger">
                        {maskNumber(
                          (value.price.ask_price * USDTPrice).toFixed(5)
                        )}
                      </td>
                      <td className="text-danger">
                        {maskNumber(value.price.ask_price.toFixed(5))}
                      </td>
                      <td className="text-danger">
                        {maskNumber(
                          (value.price.bid_price * USDTPrice).toFixed(5)
                        )}
                      </td>
                      <td className="text-danger">
                        {maskNumber(value.price.bid_price.toFixed(5))}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default CryptoPrices;
